import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/Sidebar.css";
import { IoHome, IoNewspaper, IoPricetagsOutline } from "react-icons/io5";
import { MdAddBox } from "react-icons/md";

export default function Sidebar({ isOpen, onClose }) {
  return (
    <>
      {isOpen && <div className="sidebar-backdrop" onClick={onClose} />}

      <aside className={"sidebar" + (isOpen ? " sidebar-open" : "")}>
        <div className="sidebar-brand">
          <span className="sidebar-brand-mark"><img src="/assets/icon.png" alt="TT" /></span>
          <span className="sidebar-brand-text">Today Talks</span>
          <button
            className="sidebar-close"
            onClick={onClose}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <NavLink
          to="/"
          end
          onClick={onClose}
          className={({ isActive }) =>
            "sidebar-link sidebar-link-home" + (isActive ? " sidebar-link-active" : "")
          }
        >
          <span className="sidebar-link-icon"><IoHome /></span>
          Overview
        </NavLink>

        <nav className="sidebar-nav">
          <p className="sidebar-nav-heading">Manage</p>

          <NavLink
            to="/categories"
            onClick={onClose}
            className={({ isActive }) =>
              "sidebar-link" + (isActive ? " sidebar-link-active" : "")
            }
          >
            <span className="sidebar-link-icon"><IoPricetagsOutline /></span>
            Categories
          </NavLink>

          <NavLink
            to="/posts/create"
            onClick={onClose}
            className={({ isActive }) =>
              "sidebar-link" + (isActive ? " sidebar-link-active" : "")
            }
          >
            <span className="sidebar-link-icon"><MdAddBox /></span>
            Add Posts
          </NavLink>

          <NavLink
            to="/posts"
            end
            onClick={onClose}
            className={({ isActive }) =>
              "sidebar-link" + (isActive ? " sidebar-link-active" : "")
            }
          >
            <span className="sidebar-link-icon"><IoNewspaper /></span>
            Posts
          </NavLink>
        </nav>
      </aside>
    </>
  );
}
